import {LocalDate} from '@js-joda/core';
import getConfigForDate from '@/functions/getConfigForDate';
import type {CapacityConfig} from '@/types/CapacityConfig';

export const subDisplayDate = (date : Date) : string => {
    return (date.getMonth() + 1).toString() + '/' + (date.getDate()).toString();
};

const buildSubDisplayDateConfig = (
    capacityConfig : CapacityConfig,
    yearMonthsDisplay : string[]
) : Record<string, string> => {
    const subDisplay : Record<string, string> = {};

    for (const capacityYearMonth of yearMonthsDisplay) {
        const capacityYearMonthSplit = capacityYearMonth.split('-');
        const theDate = LocalDate.of(
            parseInt(capacityYearMonthSplit[0]),
            parseInt(capacityYearMonthSplit[1]),
            1
        );
        const foundConfig = getConfigForDate(capacityConfig, theDate);

        if (foundConfig) {
            subDisplay[capacityYearMonth] = subDisplayDate(new Date(foundConfig.fiscalstart))
                + ' - ' + subDisplayDate(new Date(foundConfig.fiscalend));
        }
    }

    return subDisplay;
};

export default buildSubDisplayDateConfig;
